import Text from "common/values/text/text";

export default class FeeScheduleCategoryName extends Text {
  constructor(value: string) {
    super(value);
  }

  public get isEmpty(): boolean {
    return this.value === '';
  }
  public isEqualTo(other: Text): boolean {
    return super.isEqualTo(other);
  }

  public override clone(): FeeScheduleCategoryName {
    return new FeeScheduleCategoryName(this.value);
  }

  public static get Prototype(): FeeScheduleCategoryName {
    return new FeeScheduleCategoryName('Prototype');
  }

  public override fromJSON(value: string): FeeScheduleCategoryName {
    return new FeeScheduleCategoryName(value);
  }
  public toJSON(): string {
    return this._value;
  }
}
